export default __webpack_public_path__ + "static/media/add_btn.5516f248.svg";